import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { DisableAutofillDirective } from '../../../shared/directives/disable-autofill.directive';
import { SharedService } from '../../../shared/services/shared.service';
import { InviteSignupProcessService } from '../../services/invite-signup-process.service';

@Component({
  selector: 'app-invite-signup-process-sms',
  templateUrl: './invite-signup-process-sms.component.html',
  styleUrls: ['./invite-signup-process-sms.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    LocalisePipe,
    MatIcon,
    DisableAutofillDirective,
  ],
})
export class InviteSignupProcessSmsComponent implements OnInit {
  public error = '';
  public loading = false;

  constructor(
    public inviteSignupProcessService: InviteSignupProcessService,
    private sharedService: SharedService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    if (this.authenticationService.getProfileState().isPhoneNumberConfirmed) {
      this.inviteSignupProcessService.nextStep();
      return;
    }
  }

  public async next(): Promise<void> {
    if (this.inviteSignupProcessService.smsForm.invalid) {
      return;
    }

    this.loading = true;

    try {
      await this.inviteSignupProcessService.sendConfirmationCode();
      this.inviteSignupProcessService.nextStep();
    } catch (e) {
      this.error = this.sharedService.getErrorText(
        e,
        true,
        this.inviteSignupProcessService.smsForm,
      );
    }

    this.loading = false;
  }
}
